import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
export interface GoogleConfig {
  googleClientId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigGoogleService {
   private appConfig: GoogleConfig | undefined;

  
  constructor(private http: HttpClient) { }

   // This method is called by the APP_INITIALIZER
  loadAppConfig() {
    // Replace with your actual API endpoint
    return this.http.get<GoogleConfig>(environment.serverAPI+ '/api/catalog/siteData')
      .toPromise()
      .then((data:any) => {
       console.log(data);
        this.appConfig = data;
      });
  }

  // Getter to provide the loaded client ID
  get googleClientId(): string {
    if (!this.appConfig) {
      throw new Error('Configuration not loaded!');
    }
    return this.appConfig['apiKey'];
  }
}
